export default __webpack_public_path__ + "static/media/BCA18.998e47c6.jpg";